import { createContext, useContext } from "react";
import { NetworkContextValue } from "../types/network";

export const NetworkProviderContext = createContext<NetworkContextValue | null>(
    null,
);

export function useNetworkStatus(): NetworkContextValue {
    const context = useContext(NetworkProviderContext);
    if (!context) {
        throw new Error(
            "useNetworkStatus must be used within a NetworkProvider",
        );
    }
    return context;
}
